import React, {
    useState,
    useEffect,
    useContext,
    useRef,
    useCallback,
  } from "react";
import Modalchangcustomer from "./modaleditdo";
import { dataproduct } from "../queue/datalist";
import { getdataweightno } from "../../services/wms";
import ScrollToTop from "../common/ScrollToTop";
import BranchContext from "../context/branch";
import Input from "../wms/input";
import DatePicker from "react-datepicker";
import moment from "moment";


const Editstore = (status) => {
    const { currentBranch } = useContext(BranchContext);
  const [dataweight, setdataweight] = useState([]);
  const [isOpen, setisOpen] = useState(false);
  const [dataedit, setdataedit] = useState([]);
  const [datausers, setdatausers] = useState([]);
  const [search, setsearch] = useState("");
  const [name, setname] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  
  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getdataweightno(
        currentBranch._id,
        moment(startDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
        30,
        1,
        search,
        pageNumber
      );

      if (result.status === "success") {
        setdataweight(result.data.list);
      }
    };
    loadData();
  }, [currentBranch, search, startDate, endDate, pageNumber]);
 
  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handleCancle = () => {
    setisOpen(false);
  };
  // const handleonClickclose = (event) => {
  //   setList(false);
  // };
  const handleonClikisopen = (id) => {
    setdataedit({});
    const subdata = [...dataweight];
    const index = dataweight.findIndex((x) => x.AutoID === id);
    setdataedit([dataweight[index]]);
    setisOpen(true);
  };
  const onConfirm = () => {
    setisOpen(false);
  };
  const handleOnchang = (event) => {
    setname(event.target.value);
  };
  const handleOnclick = () => {
    setsearch(name);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setsearch(name);
      //setPageNumber(1);
    }
  };
  const handleChangStartDate = (event) => {
    setStartDate(event);
    setPageNumber(1);
  };
  const handleChangEndDate = (event) => {
    setEndDate(event);
    setPageNumber(1);
  };


    return ( 
        <>  <Modalchangcustomer
        onCancel={handleCancle}
        onConfirm={onConfirm}
        list={dataedit}
        isOpen={isOpen}
        status="7"
      />

      <div className="row">
        <div className="col-auto">
          <span> จากวันที่</span>
          <div>
            <DatePicker
              className="datepicker-default form-control"
              todayButton="Today"
              dateFormat="dd/MM/yyyy"
              selected={startDate}
              onChange={handleChangStartDate}
            />
          </div>
        </div>
        <div className="col-auto">
          <span> ถึงวันที่</span>
          <div>
            <DatePicker
              className="datepicker-default form-control"
              todayButton="Today"
              dateFormat="dd/MM/yyyy"
              selected={endDate}
              onChange={handleChangEndDate}
            />
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <Input
            name="weightno"
            value={name}
            placeholder="ทะเบียนรถ/เลขที่ใบชั่ง 4 ตัวท้าย"
            onChange={handleOnchang}
            onKeyPress={handleKeyPress}
            onClick={handleOnclick}
            search="ค้นหา"
          />
        </div>

        <div className="col-lg-3  col-md-4 col-sm-6 text-end">
          <div className="mt-3">
            <span className="badge rounded bg-primary fs-4 m-2">
              <i className="bi bi-gear me-2"></i>
               แก้ไขปลายทาง
            </span>
          </div>
        </div>
        </div>
        <p className="text-success mt-2">
          แสดงข้อมูล {dataweight ? dataweight.length : 0} รายการ บนระบบ
        </p>
 
        {dataweight &&
            dataweight.length > 0 &&
            dataweight.map((item, index) => (
              <div className="card1 shadow  mt-2" key={index}>
                <div className="row m-2 " ref={lastBookElementRef}>
                  <div className=" col-xs-6 col-sm-4 col-md-2  ">
                    <div className="row">
                      <span
                        className=" text-primary col-auto fw-bold"
                        style={{ fontSize: 12 }}
                      >
                        {index + 1}
                      </span>
                      <span className="badge rounded-pill bg-primary mb-1 col-auto">
                        {item.Weight_No}
                      </span>
                      <span className="text-dark">
                        <small style={{ fontSize: 14 }}>
                          {" "}
                          {item.Customer_name}
                        </small>
                      </span>
                      <span className="text-dark">
                        <small style={{ fontSize: 14 }}>
                          {" "}
                          {item.CustomerType_name}
                        </small>
                      </span>
                    </div>
    
                    <div />
                  </div>
    
                  <div className=" col-xs-6 col-sm-4 col-md-2 lg-1 ">
                    <div className="row">
                      <span className="text-dark">
                        ประเภทสินค้า :
                        <small className="text-dark" style={{ fontSize: 14 }}>
                          {" "}
                          {item.Type_name}
                        </small>
                      </span>
    
                      <span className="text-dark">
                        ชื่อสินค้า :
                        <small style={{ fontSize: 14 }}> {item.Product_name}</small>
                      </span>
                      <span className="text-dark">
                        วัตถุประสงค์ :
                        <small style={{ fontSize: 14 }}> {item.aim_name}</small>
                      </span>
                    </div>
    
                    <div />
                  </div>
                  <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div className="row">
                      <span className="text-dark">
                        สถานที่จัดเก็บ :
                        <small style={{ fontSize: 14 }}> {item.Store_name}</small>
                        &nbsp;
                      </span>
    
                      <span className="text-dark">
                        การจ่ายเงิน :
                        <small style={{ fontSize: 14 }}> {item.PayType}</small>
                      </span>
                      <span className="text-dark">
                        ชื่อคนขับ :
                        <small style={{ fontSize: 14 }}> {item.Driver_name}</small>
                      </span>
                    </div>
                  </div>
                  <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div className="row">
                      <span className="text-dark ">
                        ประเภทรถ :
                        <small style={{ fontSize: 14 }}> {item.TruckType}</small>
                      </span>
                      <span className="text-dark">
                        ทะเบียนหัว :
                        <small style={{ fontSize: 14 }}>
                          {" "}
                          {item.First_driven_no} {item.First_driven_prov}
                        </small>
                      </span>
                      <span className="text-dark">
                        ทะเบียนหาง :
                        <small style={{ fontSize: 14 }}>
                          {" "}
                          {item.Second_driven_no} {""} {item.Second_driven_prov}
                        </small>
                      </span>
                    </div>
                  </div>
    
                  <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div className="row">
                      <span className="text-dark">
                        น้ำหนักสุทธิ :
                        <span
                          className="badge rounded-pill bg-info ms-2"
                          style={{ fontSize: 14 }}
                        >
                          {item.Receive_weightnet}{" "}
                        </span>
                      </span>
                      <span className="text-dark">
                        DO :
                        <small style={{ fontSize: 14 }}>{item.Delivery_No} </small>
                      </span>
                      <span className="text-dark">
                        วันที่บันทึก :
                        <small className="ms-1" style={{ fontSize: 14 }}>
                          {item.DateRecord}{" "}
                        </small>
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-2  d-flex align-items-center d-flex justify-content-end">
                    <i
                      onClick={() => handleonClikisopen(item.AutoID)}
                      className="bi bi-pencil-square me-2 text-info"
                      style={{ fontSize: "25px", cursor: "pointer" }}
                    ></i>
                  </div>
                </div>
              </div>
            ))}
               </>
        );
             
              



};

export default Editstore;
